"use client";

import { useEffect } from "react";

import {
  captureHostAttribution,
  captureMarketingAttribution,
} from "@/lib/marketing-attribution";

/** Message decoda.js on a clinic page answers with the visit's attribution. */
const FRAME_READY = "DECODA_FRAME_READY";
const HOST_ATTRIBUTION = "DECODA_ATTRIBUTION";

function readHostParams(data: unknown): Record<string, string> | null {
  if (!data || typeof data !== "object") return null;
  const message = data as { type?: unknown; params?: unknown };
  if (message.type !== HOST_ATTRIBUTION) return null;
  if (!message.params || typeof message.params !== "object") return null;
  return Object.fromEntries(
    Object.entries(message.params).filter(
      (entry): entry is [string, string] => typeof entry[1] === "string",
    ),
  );
}

/**
 * Records where the visitor came from the moment a booking or shop page
 * mounts, before any router work can strip the URL. Inside a clinic's site,
 * it also asks the site's decoda.js tag for the landing the frame can't see.
 */
export function MarketingCapture() {
  useEffect(() => {
    captureMarketingAttribution();
    if (window.parent === window) return;

    const onMessage = (event: MessageEvent) => {
      if (event.source !== window.parent) return;
      const params = readHostParams(event.data);
      if (params) captureHostAttribution(params);
    };
    window.addEventListener("message", onMessage);
    window.parent.postMessage({ type: FRAME_READY }, "*");
    return () => window.removeEventListener("message", onMessage);
  }, []);
  return null;
}
